import { render, staticRenderFns } from "./FunnelChart4.vue?vue&type=template&id=06f95804&scoped=true&"
import script from "./FunnelChart4.vue?vue&type=script&lang=js&"
export * from "./FunnelChart4.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChart4.vue?vue&type=style&index=0&id=06f95804&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f95804",
  null
  
)

export default component.exports